import PubSub from "underpub-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

window.requestAnimationFrame = window.requestAnimationFrame.bind(window);
gsap.registerPlugin(ScrollTrigger);

var ContentIconItemsTimeline = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ContentIconItemsTimeline',
	};

	$.extend(true, this.options, options);

};

ContentIconItemsTimeline.prototype.init = function() {

	var self = this;

	this.$dotsContainer = this.options.$el.find(`.${self.options.baseClass}__dots`);
	this.$iconItems = this.options.$el.find(`.${self.options.baseClass}__iconItemWrapper`);
	this.$iconItemCircles = this.$iconItems.find(`.${self.options.baseClass}__circleMarker`);
	this.$gridContainer = this.options.$el.find('.grid-container');

	this.dotNumber = 1;
	this.dotSectionNumber = 1;
	this.sideNumDotsBeforeCurve;

	this.animationStarted = false;
	this.animationComplete = false;

	// setting up some variables that will determine how dots are laid out
	this.dotHeightWidth = 6;
	this.spaceBetweenDots = 14;
	this.spaceAroundCircles = 20;
	this.addlSpaceAroundCircles = 0;

	// determine how many listings we're showing per row on large screens
	this.numListingsUp = 4;

	if (this.options.$el.hasClass(`${self.options.baseClass}--twoUp`))
	{
		this.numListingsUp = 2;
	}

	this.reverseRows();

	ScrollTrigger.create({
		trigger: ".comp-ContentIconItemsTimeline",
		start: "top 25%",
		end: "25% top",
		// markers: true,
		onToggle: function({progress, direction, isActive}) {

			if (isActive && !self.animationStarted)
			{
				self.addDots();
			}

		}
	});

	$(window).resize(function() {
		self.clearDots();
	});

	PubSub.subscribe("resized", function() {

		if (self.animationStarted)
		{
			self.animationComplete = true;
			self.addDots();
		}

		
	});

};

/*
 *	This function adds classes to the icons so that every other row is reversed
 */
ContentIconItemsTimeline.prototype.reverseRows = function() {

	var self = this;

	for (var i = 1; i <= this.$iconItems.length; i++)
	{

		var $thisItem = $(this.$iconItems[i - 1]);

		// we're only setting large styles if the component is set to 4 up, otherwise we use 2 up
		if (self.numListingsUp == 4)
		{

			if (i % 8 == 5)
			{
				// left item
				if (self.$iconItems.length - i == 0)
				{
					// last item
					$thisItem
						.addClass( `${self.options.baseClass}__iconItemWrapper--largeMarginLeft` )
						.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + i );
				}
				else if (self.$iconItems.length - i == 1)
				{
					// next to last item
					$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i + 1) );
				}
				else if (self.$iconItems.length - i == 2)
				{
					// second to last item
					$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i + 2) );
				}
				else
				{
					// three before last item, or not in last row
					$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i + 3) );
				}

			}
			else if (i % 8 == 6)
			{
				// second item
				if (self.$iconItems.length - i == 0)
				{
					// last item
					$thisItem
						.addClass( `${self.options.baseClass}__iconItemWrapper--largeMarginLeft` )
						.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i - 1) );
				}
				else if (self.$iconItems.length - i == 1)
				{
					// next to last item
					$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + i );
				}
				else
				{
					// second to last item or not in last row
					$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i + 1) );
				}

			}
			else if (i % 8 == 7)
			{
				// third item
				if (self.$iconItems.length - i == 0)
				{
					// last item
					$thisItem
						.addClass( `${self.options.baseClass}__iconItemWrapper--largeMarginLeft` )
						.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i - 2) );
				}
				else
				{
					// second to last item or not in last row
					$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i - 1) );
				}

			}
			else if (i % 8 == 0)
			{
				// last item
				$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + (i - 3) );
			}
			else
			{
				// not in a row that needs to be reversed
				$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--largeOrder` + i );
			}

		}

		// medium
		if (i % 4 == 3)
		{
			// left item

			if (self.$iconItems.length - i == 0)
			{
				// last item
				$thisItem
					.addClass( `${self.options.baseClass}__iconItemWrapper--mediumMarginLeft` )
					.addClass( `${self.options.baseClass}__iconItemWrapper--mediumOrder` + i );
			}
			else
			{
				// not last item
				$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--mediumOrder` + (i + 1) );
			}
			
		}
		else if (i % 4 == 0)
		{
			// right item
			$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--mediumOrder` + (i - 1) );
		}
		else
		{
			// not in a row that needs to be reversed
			$thisItem.addClass( `${self.options.baseClass}__iconItemWrapper--mediumOrder` + i );
		}

	}

};

ContentIconItemsTimeline.prototype.showDotsWithoutAnimating = function() {

	var self = this;

	this.$dotsContainer.children().addClass(`${self.options.baseClass}__dot--shown`);
	this.$iconItemCircles.addClass(`${self.options.baseClass}__circleMarker--shown`);

};

ContentIconItemsTimeline.prototype.animateIn = function() {

	var self = this;

	this.animationStarted = true;

	var $firstCircle = this.$iconItemCircles.first();

	this.animateCircleIn($firstCircle);

};

ContentIconItemsTimeline.prototype.animateDotSectionIn = function($firstDot) {

	var self = this;

	var dotTimeGap = 40;

	var $dotToShow = $firstDot;
	var dotSectionNumber = $dotToShow.data('dotSectionNumber');
	var $nextCircle = this.options.$el.find(`.${self.options.baseClass}__circleMarker` + '[data-item-number="' + (dotSectionNumber + 1) + '"]')

	$dotToShow.addClass(`${self.options.baseClass}__dot--shown`);

	var dotSectionInterval = setInterval(function() {

		if (self.animationComplete)
		{
			clearInterval(dotSectionInterval);
			return;
		}

		// get next dot
		$dotToShow = $dotToShow.next();

		if ( $dotToShow.length && $dotToShow.data('dotSectionNumber') == dotSectionNumber )
		{
			// dot exists and is in this section
			$dotToShow.addClass(`${self.options.baseClass}__dot--shown`);
		}
		else
		{
			// we've either run out of dots, or the next dot isn't in this section
			clearInterval(dotSectionInterval);

			if ($nextCircle.length)
			{
				self.animateCircleIn($nextCircle);
			}

		}

	}, dotTimeGap );

};

ContentIconItemsTimeline.prototype.animateCircleIn = function($circle) {

	var self = this;
	var followingSectionNumber = $circle.data('itemNumber');

	$circle.addClass(`${self.options.baseClass}__circleMarker--shown`);

	var $followingDot = this.$dotsContainer.children().filter(function() {
		return $(this).data('dotSectionNumber') == followingSectionNumber;
	}).first();

	setTimeout(function() {

		if (!self.animationComplete)
		{

			if ($followingDot.length)
			{
				self.animateDotSectionIn($followingDot);
			}
			else
			{
				self.animationComplete = true;
			}
			
		}
		

	}, 400);
	

};

ContentIconItemsTimeline.prototype.clearDots = function() {

	var self = this;

	this.$dotsContainer.html('');
	this.dotNumber = 1;
	this.dotSectionNumber = 1;
	this.addlSpaceAroundCircles = 0;

};

ContentIconItemsTimeline.prototype.addDots = function() {

	var self = this;

	// clear out dots before adding them in again
	this.clearDots();

	var breakpoint = window.Breakpoint.value;
	
	// determine how close to the edge of the page we want our dots to be

	var iconItemsPerRow;
	
	// setting some values that will be used to calculate dot positions
	if (breakpoint == 'xsmall')
	{
		iconItemsPerRow = 1;
	}
	else if (breakpoint == 'small')
	{
		iconItemsPerRow = 1;
	}
	else if (breakpoint == 'medium')
	{
		iconItemsPerRow = 2;
	}
	else if (breakpoint == 'large')
	{
		iconItemsPerRow = 2;
	}
	else if (breakpoint == 'xlarge')
	{
		iconItemsPerRow = self.numListingsUp;
	}
	else if (breakpoint == 'xxlarge')
	{
		iconItemsPerRow = self.numListingsUp;
	}

	var browserWidth = $('body').innerWidth();

	if (browserWidth <= 400)
	{
		this.sideNumDotsBeforeCurve = 3;
		this.spaceBetweenDots = 12;
	}
	else if (browserWidth <= 430)
	{
		this.sideNumDotsBeforeCurve = 3;
		this.spaceBetweenDots = 14;
	}
	else if (browserWidth <= 480)
	{
		this.sideNumDotsBeforeCurve = 4;
		this.spaceBetweenDots = 14;
	}
	else if (browserWidth <= 768)
	{
		this.sideNumDotsBeforeCurve = 5;
		this.spaceBetweenDots = 14;
	}
	else if (browserWidth <= 860)
	{
		this.sideNumDotsBeforeCurve = 3;
		this.spaceBetweenDots = 14;
	}
	else if (browserWidth <= 940)
	{
		this.sideNumDotsBeforeCurve = 4;
		this.spaceBetweenDots = 14;
	}
	else if (browserWidth <= 1024)
	{
		this.sideNumDotsBeforeCurve = 5;
		this.spaceBetweenDots = 14;
	}
	else if (browserWidth <= 1180)
	{
		this.sideNumDotsBeforeCurve = 6;
		this.spaceBetweenDots = 15;
	}
	else if (browserWidth <= 1350)
	{
		this.sideNumDotsBeforeCurve = 3;
		this.spaceBetweenDots = 13;
	}
	else if (browserWidth <= 1440)
	{
		this.sideNumDotsBeforeCurve = 4;
		this.spaceBetweenDots = 13;
	}
	else if (browserWidth <= 1680)
	{
		this.sideNumDotsBeforeCurve = 4;
		this.spaceBetweenDots = 14;
	}
	else
	{
		this.sideNumDotsBeforeCurve = 6;
		this.spaceBetweenDots = 14;
	}

	this.$iconItemCircles.each(function(index) {

		var itemNumber = index + 1;
		var nextItemNumber = itemNumber + 1;

		var $startItemCircle = $(this);
		var $endItemCircle = self.$iconItems.find(`.${self.options.baseClass}__circleMarker` +'[data-item-number="' + nextItemNumber + '"]');

		if (!$endItemCircle.length)
		{
			return;
		}

		if (itemNumber % iconItemsPerRow == 0 && itemNumber % ( iconItemsPerRow * 2 ) == 0)
		{
			self.addDotsVerticalLeftSide($startItemCircle, $endItemCircle);
		}
		else if (itemNumber % iconItemsPerRow == 0)
		{
			self.addDotsVerticalRightSide($startItemCircle, $endItemCircle);
		}
		else if (itemNumber % ( iconItemsPerRow * 2 ) <= iconItemsPerRow)
		{
			self.addDotsHorizontalLeftToRight($startItemCircle, $endItemCircle);
		}
		else
		{
			self.addDotsHorizontalRightToLeft($startItemCircle, $endItemCircle);
		}

		self.dotSectionNumber++;

	});

	if (self.animationComplete)
	{
		self.showDotsWithoutAnimating();
	}
	else
	{
		self.animateIn();
	}

};

ContentIconItemsTimeline.prototype.addDotsHorizontalLeftToRight = function($itemCircle1, $itemCircle2) {

	var self = this;

	// console.log('add dots horizontal left to right');

	// get our circle coordinates
	var componentTop = this.options.$el.offset().top;
	var circle1Top = $itemCircle1.offset().top - componentTop;

	var circle1Right = $itemCircle1.offset().left + $itemCircle1.outerWidth();
	var circle2Left = $itemCircle2.offset().left;

	// get space between circles
	var spaceBetweenCircles = circle2Left - circle1Right;

	// get number of dots that will fit
	var spaceForDots = spaceBetweenCircles - ( this.spaceAroundCircles * 2 );

	var numberOfDots = Math.floor( (spaceForDots - this.dotHeightWidth) / ( this.dotHeightWidth + this.spaceBetweenDots ) ) + 1;

	// get vertical position of dots
	var dotY = circle1Top + ( $itemCircle1.outerHeight() / 2 ) - ( this.dotHeightWidth / 2 );

	// getting some variables
	var spaceDotsWillUse = ( ( numberOfDots - 1 ) * ( this.dotHeightWidth + this.spaceBetweenDots ) ) + this.dotHeightWidth;
	this.addlSpaceAroundCircles = ( spaceForDots - spaceDotsWillUse ) / 2;
	var dotX = circle1Right + this.spaceAroundCircles + this.addlSpaceAroundCircles;

	for (var i = 1; i <= numberOfDots; i++) {
		
		this.addDot(self.dotNumber++, dotX, dotY);

		dotX += ( this.dotHeightWidth + this.spaceBetweenDots );

	}

};

ContentIconItemsTimeline.prototype.addDotsHorizontalRightToLeft = function($itemCircle1, $itemCircle2) {

	var self = this;

	// console.log('add dots horizontal right to left');

	// get our circle coordinates
	var componentTop = this.options.$el.offset().top;
	var circle1Top = $itemCircle1.offset().top - componentTop;

	var circle1Left = $itemCircle1.offset().left;
	var circle2Right = $itemCircle2.offset().left + $itemCircle2.outerWidth();

	// get space between circles
	var spaceBetweenCircles = circle1Left - circle2Right;

	// get number of dots that will fit
	var spaceForDots = spaceBetweenCircles - ( this.spaceAroundCircles * 2 );

	var numberOfDots = Math.floor( (spaceForDots - this.dotHeightWidth) / ( this.dotHeightWidth + this.spaceBetweenDots ) ) + 1;

	// get vertical position of dots
	var dotY = circle1Top + ( $itemCircle1.outerHeight() / 2 ) - ( this.dotHeightWidth / 2 );

	// getting some variables
	var spaceDotsWillUse = ( ( numberOfDots - 1 ) * ( this.dotHeightWidth + this.spaceBetweenDots ) ) + this.dotHeightWidth;
	this.addlSpaceAroundCircles = ( spaceForDots - spaceDotsWillUse ) / 2;
	var dotX = circle1Left - this.spaceAroundCircles - this.addlSpaceAroundCircles - this.dotHeightWidth;

	for (var i = 1; i <= numberOfDots; i++) {
		
		this.addDot(self.dotNumber++, dotX, dotY);

		dotX -= ( this.dotHeightWidth + this.spaceBetweenDots );

	}

};

ContentIconItemsTimeline.prototype.addDotsVerticalRightSide = function($itemCircle1, $itemCircle2) {

	var self = this;
	var dotX, dotY;

	// get our circle coordinates
	var componentTop = this.options.$el.offset().top;
	var circle1Top = $itemCircle1.offset().top - componentTop;
	var circle2Top = $itemCircle2.offset().top - componentTop;

	var circle1Right = $itemCircle1.offset().left + $itemCircle1.outerWidth();
	var circle2Right = $itemCircle2.offset().left + $itemCircle2.outerWidth();

	// get initial dot position
	dotY = circle1Top + ( $itemCircle1.outerHeight() / 2 ) - ( this.dotHeightWidth / 2 );
	dotX = circle1Right + this.spaceAroundCircles + this.addlSpaceAroundCircles;

	// add horizontal dots coming from first circle
	for (var i = 1; i <= this.sideNumDotsBeforeCurve; i++) {
		
		this.addDot(self.dotNumber++, dotX, dotY);

		dotX += ( this.dotHeightWidth + this.spaceBetweenDots );

	}

	// add top right curve
	var firstCurveDotY = dotY;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots );
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots );

	var lastCurveDotY = dotY;

	this.addDot(self.dotNumber++, dotX, dotY);

	// need to do a bunch math here to determine how large our curve is so we can determine how many dots go between the curves
	var curveHeight = lastCurveDotY - firstCurveDotY + ( this.dotHeightWidth / 2 );
	var spaceBetweenCurves = ( circle2Top - circle1Top ) - ( curveHeight * 2 ); // total space between bottom of top curve and top of bottom curve
	var verticalSpaceForDots = spaceBetweenCurves - ( this.spaceBetweenDots * 2 ); // max space that dots should occupy, making sure there is minimum of spaceBetweenDots between dots
	var numberOfVerticalDots = Math.floor( ( verticalSpaceForDots - this.dotHeightWidth ) / ( this.dotHeightWidth + this.spaceBetweenDots ) ) + 1;

	// the vertical space between dots
	// we add dotHeightWidth at the end here because otherwise we're setting distance between tops of dots, and based on the math used we need distance between the dots
	// this essentially just divides up the space between the dots evenly so there are no gaps
	var verticalSpace = ( ( spaceBetweenCurves - ( numberOfVerticalDots * this.dotHeightWidth ) ) / ( numberOfVerticalDots + 1 ) ) + this.dotHeightWidth;

	for (var i = 1; i <= numberOfVerticalDots; i++) {
		
		dotY += verticalSpace;

		this.addDot(self.dotNumber++, dotX, dotY);

	}

	dotY += verticalSpace;


	// add bottom right curve
	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots );

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots );
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;

	this.addDot(self.dotNumber++, dotX, dotY);

	// add horizontal dots leading up to end circle
	for (var i = 1; i <= this.sideNumDotsBeforeCurve; i++) {
		
		dotX -= ( this.dotHeightWidth + this.spaceBetweenDots );

		this.addDot(self.dotNumber++, dotX, dotY);

	}

};

ContentIconItemsTimeline.prototype.addDotsVerticalLeftSide = function($itemCircle1, $itemCircle2) {

	var self = this;
	var dotX, dotY;

	// get our circle coordinates
	var componentTop = this.options.$el.offset().top;
	var circle1Top = $itemCircle1.offset().top - componentTop;
	var circle2Top = $itemCircle2.offset().top - componentTop;

	var circle1Left = $itemCircle1.offset().left;
	var circle2Left = $itemCircle2.offset().left;

	// get initial dot position
	dotY = circle1Top + ( $itemCircle1.outerHeight() / 2 ) - ( this.dotHeightWidth / 2 );
	dotX = circle1Left - this.spaceAroundCircles - this.addlSpaceAroundCircles - this.dotHeightWidth;

	// add horizontal dots coming from first circle
	for (var i = 1; i <= this.sideNumDotsBeforeCurve; i++) {
		
		this.addDot(self.dotNumber++, dotX, dotY);

		dotX -= ( this.dotHeightWidth + this.spaceBetweenDots );

	}

	// add top left curve
	var firstCurveDotY = dotY;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots );
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX -= ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots );

	var lastCurveDotY = dotY;

	this.addDot(self.dotNumber++, dotX, dotY);

	// need to do a bunch math here to determine how large our curve is so we can determine how many dots go between the curves
	var curveHeight = lastCurveDotY - firstCurveDotY + ( this.dotHeightWidth / 2 );
	var spaceBetweenCurves = ( circle2Top - circle1Top ) - ( curveHeight * 2 ); // total space between bottom of top curve and top of bottom curve
	var verticalSpaceForDots = spaceBetweenCurves - ( this.spaceBetweenDots * 2 ); // max space that dots should occupy, making sure there is minimum of spaceBetweenDots between dots
	var numberOfVerticalDots = Math.floor( ( verticalSpaceForDots - this.dotHeightWidth ) / ( this.dotHeightWidth + this.spaceBetweenDots ) ) + 1;

	// the vertical space between dots
	// we add dotHeightWidth at the end here because otherwise we're setting distance between tops of dots, and based on the math used we need distance between the dots
	// this essentially just divides up the space between the dots evenly so there are no gaps
	var verticalSpace = ( ( spaceBetweenCurves - ( numberOfVerticalDots * this.dotHeightWidth ) ) / ( numberOfVerticalDots + 1 ) ) + this.dotHeightWidth;

	for (var i = 1; i <= numberOfVerticalDots; i++) {
		
		dotY += verticalSpace;

		this.addDot(self.dotNumber++, dotX, dotY);

	}

	dotY += verticalSpace;

	// add bottom left curve
	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots );

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .75;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots ) * .9;
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .5;

	this.addDot(self.dotNumber++, dotX, dotY);

	dotX += ( this.dotHeightWidth + this.spaceBetweenDots );
	dotY += ( this.dotHeightWidth + this.spaceBetweenDots ) * .15;

	this.addDot(self.dotNumber++, dotX, dotY);

	// add horizontal dots leading up to end circle
	for (var i = 1; i <= this.sideNumDotsBeforeCurve; i++) {
		
		dotX += ( this.dotHeightWidth + this.spaceBetweenDots );

		this.addDot(self.dotNumber++, dotX, dotY);

	}

	

};

ContentIconItemsTimeline.prototype.addDot = function(dotNumber, dotX, dotY) {

	var self = this;

	var $dot = $('<span></span>')
		.addClass(`${self.options.baseClass}__dot`)
		.data('dotNumber', self.dotNumber++)
		.data('dotSectionNumber', self.dotSectionNumber)
		.css('left', dotX)
		.css('top', dotY);

	$dot.appendTo( self.$dotsContainer );

};

export default ContentIconItemsTimeline;
